import ShoppingListContainer from './shopping_list_container'
import ShoppingListContainerTablet from './shopping_list_container_tablet'
import { IS_TABLET } from '../../../../helpers/device';

export default IS_TABLET ? ShoppingListContainerTablet : ShoppingListContainer
